import { Table } from '@devexpress/dx-react-grid-material-ui';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

export class TableRow extends Component {
  static propTypes = {
    row: PropTypes.object.isRequired,
    tableRow: PropTypes.object.isRequired
  };

  render() {
    const { children, row, tableRow } = this.props;
    return (
      <Table.Row row={row} tableRow={tableRow}>
        {children}
      </Table.Row>
    );
  }
}

export default TableRow;
